import { HeaderMegaMenu } from 'theme';

// Keep Stretch's dialog, focus trap, animation and scroll-lock accounting.
class HviskEditorialMenu extends HeaderMegaMenu {
  connectedCallback() {
    super.connectedCallback();
    const options = { signal: this.abortController.signal };
    this.header = this.closest('x-header');
    this.desktop = window.matchMedia('(min-width: 1000px)');
    document.addEventListener('keydown', (event) => {
      // Escape must also work while the inherited entrance animation is running.
      if (event.key === 'Escape' && this.open) {
        event.preventDefault();
        this.hide();
      }
    }, { ...options, capture: true });
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-editorial-close]')) this.hide();
    }, options);
    this.addEventListener('dialog:before-show', () => {
      this.updateAvailableHeight();
      this.header?.querySelectorAll('hvisk-editorial-menu[open], header-mega-menu[open], header-dropdown-menu[open]').forEach((menu) => {
        if (menu !== this) menu.hide();
      });
    }, options);
    this.addEventListener('toggle', (event) => {
      if (!event.target.matches('details[open]')) return;
      this.querySelectorAll('details[open]').forEach((group) => {
        if (group !== event.target) group.open = false;
      });
    }, { ...options, capture: true });
    this.desktop.addEventListener('change', () => {
      if (!this.desktop.matches) this.hide();
    }, options);
    window.addEventListener('resize', () => {
      if (this.open) this.updateAvailableHeight();
    }, options);
    this.addEventListener('shopify:block:select', () => {
      if (this.desktop.matches) this.show();
    }, options);
    this.addEventListener('shopify:block:deselect', () => this.hide(), options);
  }

  updateAvailableHeight() {
    const bottom = this.header?.getBoundingClientRect().bottom || 0;
    this.style.setProperty('--hvisk-menu-available-height', `${Math.max(0, window.innerHeight - bottom)}px`);
  }

  get shouldLock() { return true; }

  get initialFocus() { return this.querySelector('[data-editorial-close]'); }

  // Guard repeated editor events and clicks so the shared lock counter stays balanced.
  show(options = {}) {
    if (this.open || !this.desktop?.matches) return Promise.resolve();
    return super.show(options);
  }

  hide() {
    if (!this.open) return Promise.resolve();
    return super.hide();
  }

  createEnterAnimationControls() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const controls = super.createEnterAnimationControls();
      controls.complete();
      return controls;
    }
    return super.createEnterAnimationControls();
  }

  createLeaveAnimationControls() {
    const controls = super.createLeaveAnimationControls();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) controls.complete();
    return controls;
  }
}

if (!customElements.get('hvisk-editorial-menu')) {
  customElements.define('hvisk-editorial-menu', HviskEditorialMenu);
}
